

import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import IBButton from "@/components/IBButton/IBButton.vue";

@Component({
	components: {
		IBButton
	}
})
export default class IBAlertFixed extends Vue {

	@Prop({ type: String, default: 'icon-warning-round' })
	readonly icon!: string

	@Prop({ type: String, default: 'alert.browserError' })
	readonly text!: string

	@Prop({ type: String, default: 'bottom' })
	readonly position!: string

	@Emit('openModalBrowserList')
	onClickModalBrowserList() {}

}
